/*
  item types:
    price - formatPrice
    boolean - yes/no (v/x)
    raw - as it is
    mixed - mix of two types, % and price
    other - include type after value, example type:'items' => '7 items'

  item suffix: include after amount and type, example: suffix: 'months' => '7 items/months'

  hidden: 'legacy' - feature exists in API, but can't be found anywhere in the old app
          'customer' - not shown in customer
          'admin' - not shown in admin

  legacy_disabled: used only in admin - feature shown, but can't be changed

  enable_field: if false don't show feature at all
                 there is two major enable_fields that affect plan features categories:
                 mail_service_enabled - if false hide everything except SpherePhone
                 phone_service_enabled - if false hide SpherePhone
                 !!!major enable_fields can't both be false at the same time

  available_field: if false show 'N/A' and may be description hint

  ref_to and ref_from: two tied features, if both features == 0, then unlimited value. In customer we show feature with ref_to as 'unlimited' and hide feature with ref_from. In Admin show hint for unlimited and not allow ref_to when ref_from == 0;
  ref_title: used as title when feature shown as ref_to

  discount_field: corresponds to discount attached to feature (conf room and day pass)
*/

export default {
  mailbox_services: [
    {
      field: 'setup_fee',
      type: 'price',
      title: 'Setup fee',
      empty_title: 'No Setup Fee',
      desc:"One-time charge collected from customers upon subscribing."
    },
    {
      field: 're_use_pmb_fee',
      type: 'price',
      title: 'Retrieve old mailbox#',
      hidden: 'customer',
      desc:"OTC if a customer wants to retrieve their PMB when resubscribing."
    },
    {
      field: 'facility_security_deposit',
      type: 'price',
      title: 'Security deposit',
      desc: "One-time payment collected upon subscribing to cover any losses as per your TOS."
    },
    {
      field: 'has_private_mailbox',
      type: 'boolean',
      title: 'Private mailbox number',
      legacy_disabled: true,
      customer: {
        title: 'Your own private mailbox number'
      }
    },
    {
      field: 'has_live_receptionist',
      type: 'boolean',
      title: 'Live Receptionist'
    },
    {
      field: 'has_business_address',
      type: 'boolean',
      title: 'Business mailing address, NOT a P.O. Box',
      hidden: 'admin'                                             // ?
    },
    {
      field: 'has_email_received_mail',
      type: 'boolean',
      title: 'Email notification',
      legacy_disabled: true,
      customer: {
        title: 'Email notification of received mail and packages'
      }
    },
    {
      field: 'sms_service',
      type: 'boolean',
      title: 'SMS notification',
      hidden: 'customer'
    },
    {
      field: 'has_list_received_mail',
      type: 'boolean',
      title: 'Detailed list of received mail and packages (sender, date, status, etc.)',
      hidden: 'admin'
    },
    {
      field: 'has_mail_forwarding',
      type: 'boolean',
      title: 'Include Mail Forwarding'
    },
    {
      field: 'has_mail_scanning',
      type: 'boolean',
      title: 'Include Mail Scanning'
    },
    {
      field: 'has_letter_shredding',
      type: 'boolean',
      title: 'Letter shredding',
      hidden: 'legacy'                                                       // ?
    },
    {
      field: 'complimentary_mail_items',
      type: 'items',
      suffix: 'month',
      title: 'Complimentary mail items / month',
      ref_to: 'price_per_mail_item',
      desc: "Number of incoming mail items free of charge per month."
    },
    {
      field: 'complimentary_scans',
      type: 'items',
      suffix: 'month',
      title: 'Complimentary letter scanning / month',
      customer: {
        title: 'Letter scanning to a PDF file'
      },
      available_field: 'has_mail_scanning',
      ref_to: 'price_per_scan',
      empty_title: 'Scan service is not available',
      desc: "Number of items to be opened and scanned free of charge per month."
    },
    {
      field: 'complimentary_shreds',
      type: 'items',
      suffix: 'month',
      title: 'Complimentary letter shredding / month',
      available_field: 'has_letter_shredding',
      ref_to: 'price_per_shred',
      desc: "Number of letters to be shredded free of charge per month."
    },
    {
      field: 'complimentary_forward_amount',
      type: 'items',
      suffix: 'month',
      title: 'Free forwardings',
      hidden: 'legacy',
      available_field: 'has_mail_forwarding'
    }
  ],
  facility_privileges: [
    {
      field: 'complimentary_days',
      type: 'days',
      suffix: 'month',
      title: 'Day pass access',
      discount_field: 'day_pass_discount_pct'
    },
    {
      field: 'complimentary_conf_room_hours',
      type: 'hours',
      suffix: 'month',
      title: 'Conference room hours',
      disable_title: 'Conference Room Access is extra',
      // discount_field: 'conf_room_discount_pct',
      pricing: {
        type: ''
      }
    },
    {
      field: 'has_conf_room_discount',
      type: 'boolean',
      title: 'Conference room discount available',
      hidden: 'legacy'
    },
    {
      field: 'has_day_pass_discount',
      type: 'boolean',
      title: 'Day pass discount available',
      hidden: 'legacy'
    },
    {
      field: 'day_pass_discount_pct',
      flag_field: 'day_pass_discount_amount',
      type: 'flagged',
      title: 'Day pass discount',
      admin: {
        type: 'discount'
      },
      available_field: 'has_day_pass_discount'
    },
    { // used to show feature, values taken from conference_rooms array
      field: 'conf_room_discount_amount',
      // alt_field: 'conf_room_discount_pct',
      type: 'mixed',
      title: 'Conference room discount',
      admin: {
        type: 'rooms'
      },
      available_field: 'has_conf_room_discount'
    }
  ],
  spherephone_addon: [
    {
      field: 'phone_price',
      type: 'price',
      suffix: 'month',
      title: 'Dedicated phone number',
      pricing: {
        title: 'Virtual Phone',
        suffix: 'month (optional)'
      },
      desc:"Monthly charge per purchased virtual phone number."
    },
    {
      field: 'phone_price_per_minute',
      type: 'price',
      suffix: 'minute',
      title: 'Phone usage / minute',
      desc: "Charge per minute of phone usage."
    },
    {
      field: 'toll_free_phone_price',
      type: 'price',
      suffix: 'month',
      title: 'Dedicated toll-free phone number',
      desc:"Monthly charge per purchased virtual toll-free phone number."
    },
    {
      field: 'toll_free_phone_price_per_minute',
      type: 'price',
      suffix: 'minute',
      title: 'Toll-free phone usage / minute',
      desc: "Charge per minute of toll-free phone usage."
    },
    {
      field: 'sms_missed_call_cost',
      type: 'price',
      suffix: 'message',
      title: 'Text message notifications for missed calls',
      available_field: 'sms_service',
      desc: "Charge per each missed call text message."
    },
    {
      field: 'voice_mail_cost',
      type: 'price',
      suffix: 'minute',
      title: 'Voice message answering',
      desc:"Charge per each voice message."
    },
    {
      field: 'voice_personal_message_cost',
      type: 'price',
      suffix: 'month',
      title: 'Personal message for voicemail',
      desc: "Charge for setting up a custom voicemail message."
    },
    {
      field: 'has_phone_extension',
      type: 'boolean',
      title: 'Unlimited extensions',
      legacy_disabled: true
    },
    {
      field: 'has_outgoing_call',
      type: 'boolean',
      title: 'Make outgoing calls',
      legacy_disabled: true
    },
    {
      field: 'has_number_porting',
      type: 'boolean',
      title: 'Number porting',
      // legacy_disabled: true,
      desc:"Charge for porting a number into the account."
    }
  ],
  extras: [
    {
      field: 'registered_agent_service_price',
      type: 'price',
      suffix: 'month',
      title: 'Registered agent service',
      enable_field: 'registered_agent_service_enabled',
      admin: {
        title: 'Registered agent service / month'
      },
      desc:"Monthly charge for the registered agent service."
    },
    {
      field: 'check_deposit_service_price',
      type: 'price',
      suffix: 'month',
      title: 'Check deposit service',
      enable_field: 'check_deposit_service_enabled',
      admin: {
        title: 'Check deposit service / month'
      },
      desc:"Monthly charge for the check deposit service."
    },
    {
      field: 'automatic_scan_price',
      type: 'price',
      suffix: 'month',
      title: 'Automatic Scan Requests',
      enable_field: 'automatic_scan_enabled',
      admin: {
        title: 'Automatic scan requests / month'
      },
      desc: "Monthly charge for enabled automatic scan requests."
    },
    {
      field: 'automatic_forward_price',
      type: 'price',
      suffix: 'month',
      title: 'Automatic Forwarding Requests',
      enable_field: 'automatic_forward_enabled',
      admin: {
        title: 'Automatic forward requests / month'
      },
      desc: "Monthly charge for enabled automatic forward requests."
    },
    {
      field: 'joint_account_price',
      type: 'price',
      suffix: 'month',
      title: 'Additional recipients',
      empty_title: 'Additional recipients included',
      customer: {
        title: 'Additional recipient - Add additional names to your account (optional)'
      },
      admin: {
        title: 'Additional recipient / month',
      },
      desc: "Monthly charge per each <a href='https://support.spheremail.co/support/solutions/articles/69000644409-additional-recipients-%E2%86%92' target='_blank'>additional recipient</a> added to the customer account."
    },
    {
      field: 'price_per_mail_item',
      type: 'price',
      suffix: 'item',
      title: 'Additional mail',
      ref_from: 'complimentary_mail_items',
      ref_title: 'Incoming Mail Items',
      desc:"Charge per each extra item received after exceeding the free quota."
    },
    {
      field: 'price_per_sms',
      type: 'price',
      suffix: 'message',
      title: 'Automated SMS notification',
      hidden: 'customer',
      available_field: 'sms_service',
      desc: "Charge per each SMS received when a new mail item is received."
    },
    {
      field: 'mail_item_picture_price',
      type: 'price',
      suffix: 'item',
      title: 'Envelope picture',
      desc:"Charge per each requested envelope picture."
    },
    {
      field: 'price_per_scan',
      type: 'price',
      suffix: 'item',
      title: 'Additional letter scanning',
      pricing: {
        title: 'Additional Scans'
      },
      available_field: 'has_mail_scanning',
      ref_from: 'complimentary_scans',
      ref_title: 'Open and scan',
      desc: "Charge per each extra item scanned after exceeding the free quota."
    },
    {
      field: 'price_same_day_scan',
      type: 'price',
      suffix: 'item',
      title: 'Same day scanning',
      enable_field: 'expedited_scan_service_enabled',
      available_field: 'has_mail_scanning',
      desc: "Charge per each expedited request to scan an item on the same day."
    },
    {
      field: 'price_two_days_scan',
      type: 'price',
      suffix: 'item',
      title: '2 days scanning',
      enable_field: 'expedited_scan_service_enabled',
      available_field: 'has_mail_scanning',
      desc: "Charge per each expedited request to scan an item within two days."
    },
    {
      field: 'price_per_shred',
      type: 'price',
      suffix: 'item',
      title: 'Additional letter shredding',
      available_field: 'has_letter_shredding',
      hidden: 'customer',
      // ref_from: 'complimentary_shreds',
      pricing: {
        title: 'Shredding and Recycling'
      },
      desc: "Charge per each extra item shredded after exceeding the free quota."
    },
    {
      field: 'pickup_enabled',
      type: 'boolean',
      title: 'Mail pickup service',
      available_field: 'mail_service_enabled',
      desc:"Enable/disable to determine if <a href='https://support.spheremail.co/support/solutions/articles/69000337115-pickup-mail-requests-%E2%86%92' target='_blank'>the service</a> is available for customers"
    },
    {
      field: 'price_per_pickup',
      type: 'price',
      suffix: 'pickup',
      title: 'Mail pickup',
      desc:"Charge per each picked-up item."
    },
    {
      field: 'storage_price',
      type: 'price',
      suffix: 'items/month',
      title: 'Letter storage per item',
      pricing: {
        title: 'Letter Storage',
        suffix: 'item/month',
        no_dash: true
      },
      desc:"Charge per each letter <a href='https://support.spheremail.co/support/solutions/articles/69000520297-mail-storage-fees%E2%86%92' target='_blank'>stored for 30+ days</a>."
    },
    {
      field: 'package_storage_price_per_pound',
      type: 'price',
      suffix: 'pound/month',
      title: 'Parcel/Package storage per lbs/kg',
      desc:"Charge per each package <a href='https://support.spheremail.co/support/solutions/articles/69000520297-mail-storage-fees%E2%86%92' target='_blank'>stored for 30+ days</a>; calculated by weight."
    },
    {
      field: 'forward_surcharge',
      type: 'price',
      suffix: 'item + postage',
      title: 'Letter forwarding',
      available_field: 'has_mail_forwarding',
      desc:"Charge per each domestic forward request for letters (not including postage)."
    },
    {
      field: 'forward_package_surcharge',
      type: 'price',
      suffix: 'package + postage',
      title: 'Package forwarding',
      available_field: 'has_mail_forwarding',
      pricing: {
        suffix: 'item + postage'
      },
      desc: "Charge per each domestic forward request for packages (not including postage)"
    },
    {
      field: 'price_per_expedited_forward',
      type: 'price',
      suffix: 'item',
      title: 'Expedited forwarding',
      hidden: 'customer',
      available_field: 'has_mail_forwarding',
      desc:"Charge per each expedited forward request (not including postage)."
    },
    {
      field: 'int_forward_surcharge',
      type: 'price',
      suffix: 'item + postage',
      title: 'Int. letter forwarding',
      hidden: 'customer',
      available_field: 'has_mail_forwarding',
      desc:"Charge per each international forward request for letters (not including postage)."
    },
    {
      field: 'int_forward_package_surcharge',
      type: 'price',
      suffix: 'package + postage',
      title: 'Int. package forwarding',
      hidden: 'customer',
      available_field: 'has_mail_forwarding',
      desc:"Charge per each international forward request for packages (not including postage)."
    },
    {
      field: 'groupmail_forward',
      type: 'price',
      title: 'Forward items in bulk',
      hidden: 'customer',
      enable_field: 'group_mail_forward_service_enabled',
      available_field: 'has_mail_forwarding',
      desc: "Charge per each forward request for a group of mail to be shipped together (not including postage)."
    },
    {
      field: 'int_groupmail_forward',
      type: 'price',
      title: 'Int. group mail forwarding',
      hidden: 'legacy',
      enable_field: 'group_mail_forward_service_enabled',
      available_field: 'has_mail_forwarding'
    },
    {
      field: 'national_notarization_price',
      type: 'price',
      suffix: 'document',
      title: 'Notarize a document',
      hidden: 'legacy',
      enable_field: 'notarization_service_enabled',
    },
    {
      field: 'international_notarization_price',
      type: 'price',
      suffix: 'document',
      title: 'Int. notarize document',
      hidden: 'legacy',
      enable_field: 'notarization_service_enabled',
    },
    {
      field: 'facility_office_type',
      type: 'raw',
      title: 'Facility type',
      hidden: 'legacy'
    },
    {
      field: 'extra_forward_address_price',
      type: 'price',
      title: 'Additional forward addresses',
      available_field: 'has_mail_forwarding',
      desc:"Charge per each additional forward address added to customer accounts."
    }
  ],
  enablers: [
    {
      field: 'mail_service_enabled',
      type: 'boolean',
      title: 'Mail services'
    },
    {
      field: 'phone_service_enabled',
      type: 'boolean',
      title: 'SpherePhone™'
    },
    {
      field: 'check_deposit_service_enabled',
      type: 'boolean',
      title: 'Check deposit service',
      desc: "Enable/disable to determine if <a href='https://support.spheremail.co/support/solutions/articles/69000560751-the-check-deposit-feature%E2%86%92' target='_blank'>the service</a> is available for customers."
    },
    {
      field: 'expedited_scan_service_enabled',
      type: 'boolean',
      title: 'Expedited scanning',
      available_field: 'has_mail_scanning',
      desc: "Enable/disable to determine if the service is available for customers."
    },
    {
      field: 'registered_agent_service_enabled',
      type: 'boolean',
      title: 'Registered agent service',
      desc: "Enable/disable to determine if <a href='https://support.spheremail.co/support/solutions/articles/69000641843-registered-agent-service%E2%86%92' target='_blank'>the service</a> is available for customers."
    },
    {
      field: 'automatic_scan_enabled',
      type: 'boolean',
      title: 'Automatic scan requests',
      desc: "Enable/disable to determine if <a href='https://support.spheremail.co/support/solutions/articles/69000850864-automatic-mail-requests-%E2%86%92' target='_blank'>the service</a> is available for customers."
    },
    {
      field: 'automatic_forward_enabled',
      type: 'boolean',
      title: 'Automatic forward requests',
      desc: "Enable/disable to determine if <a href='https://support.spheremail.co/support/solutions/articles/69000850864-automatic-mail-requests-%E2%86%92' target='_blank'>the service</a> is available for customers."
    },
    {
      field: 'group_mail_forward_service_enabled',
      type: 'boolean',
      title: 'Bulk Mail Forwarding',
      available_field: 'has_mail_forwarding',
      desc: "Enable/disable to determine if <a href='https://support.spheremail.co/support/solutions/articles/69000344524-forward-mail-in-bulk-groupmail-forwarding-%E2%86%92' target='_blank'>the service</a> is available for customers."
    }
  ]
}